import { render } from "./VUESideMenuItem.vue?vue&type=template&id=8eee235e"
import script from "./VUESideMenuItem.vue?vue&type=script&lang=js"
export * from "./VUESideMenuItem.vue?vue&type=script&lang=js"

import "./VUESideMenuItem.vue?vue&type=style&index=0&id=8eee235e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__